document.getElementById('agree-terms').addEventListener('change', function() {
    // Get the checkout button
    var checkoutButton = document.getElementById('checkout-button');
    
    // Enable or disable the button based on checkbox state
    if (this.checked) {
      checkoutButton.disabled = false; // Enable the button
    } else {
      checkoutButton.disabled = true;  // Disable the button
    }
});